import React from 'react';
import { DefaultIconProps } from '@gamiphy/icons/types';

const Close: React.FC<DefaultIconProps> = ({
  width = '20.148', height = '20', className, onClick, style,
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20.148 20"
    onClick={onClick}
    style={style}
  >
    <path
      d="M17.734 18.783L9.5 10.563l-8.234 8.22a.735.735 0 01-1.054-.011.771.771 0 01.012-1.072l8.211-8.2L.224 1.3A.77.77 0 01.213.228.735.735 0 011.266.217L9.5 8.436 17.734.217a.735.735 0 011.054.012.77.77 0 01-.012 1.071l-8.211 8.2 8.211 8.2a.771.771 0 01.011 1.075.735.735 0 01-1.054.011z"
      data-name="Icon / Close"
      transform="translate(.574 .5)"
    />
  </svg>
);

export default Close;
